import { apiClient } from "./apiClient";

export const authApi = {
  trustDevice: (deviceName, deviceFingerprint, trustDays = 90) =>
    apiClient.post("/auth/trust-device", { device_name: deviceName, device_fingerprint: deviceFingerprint, trust_days: trustDays }).then((r) => r.data),
  revokeDevice: (deviceId) => apiClient.post("/auth/revoke-device", { device_id: deviceId }).then((r) => r.data),
  trustedDevices: () => apiClient.get("/auth/trusted-devices").then((r) => r.data),
  travelMode: (payload) => apiClient.post("/auth/travel-mode", payload).then((r) => r.data),
  logoutAll: () => apiClient.post("/auth/logout-all").then((r) => r.data),
  refresh: () => apiClient.post("/auth/refresh").then((r) => r.data),
};
